import type { I18nFn } from '#/i18n/types/I18nFn';

import { LISTING_TYPE_HUMAN_NAME_MAP_TITLE } from './listingTypeHumanNameMapTitle';

export const LISTING_TYPE_HUMAN_NAME_MAP_COUNTS = (i18n: I18nFn) => ({
  ...LISTING_TYPE_HUMAN_NAME_MAP_TITLE(i18n),
  VOLOP: i18n('Volunteer Opportunity'),
});
